import { Link } from 'react-router-dom'
import SEO from '@/components/shared/SEO'

const BlogsPage = () => {
  const blogPosts = [
    {
      id: 1,
      title:
        'Data Deletion Threatens £1bn in Car Finance Compensation for UK Borrowers',
      excerpt:
        'UK consumers could lose up to £1 billion in car finance compensation because banks and lenders have deleted crucial customer records. This alarming development comes as Britain faces one of its biggest financial scandals involving secret commissions paid to car dealers - potentially matching the scale of the £50 billion PPI compensation scheme.',
      image: '/Image/banks-delete-records-consumers-lose-billions.webp',
      date: '05 September 2025',
      author: 'James Smith',
      category: 'blogs',
    },
    {
      id: 2,
      title:
        "Can I Claim If My PCP Agreement Included GAP Insurance or Add-Ons I Didn't Ask For?",
      excerpt:
        "Have you spotted unexpected charges for GAP insurance, extended warranties, or service plans in your PCP finance deal? Many drivers don't realise these add-ons were included without clear consent. In this guide, we explain when these extra costs are mis-sold PCP car finance.",
      image: '/Image/man-getting-into-car-claims1.webp',
      date: '1 September 2025',
      author: 'Olivia Jones',
      category: 'Guide',
    },
    {
      id: 3,
      title:
        'Clydesdale Finance and the Car Loan Commissions Scandal: Can You Claim?',
      excerpt:
        'If you took out car finance with Clydesdale Bank between April 2007 and January 2021, you might be entitled to compensation. This guide explains how hidden commissions in car finance agreements may have cost you money.',
      image: '/Image/Car-photo-illustration-claims1.webp',
      date: '1 September 2025',
      author: "Shannon Smith O'Connell",
      category: 'Guide',
    },
    {
      id: 4,
      title: 'How to Claim Against Close Brothers Finance: Step-by-Step Guide',
      excerpt:
        'If you suspect your car finance agreement with Close Brothers was mis-sold, this comprehensive guide will walk you through the claims process. Learn about hidden commissions, unfair practices, and how to get the compensation you deserve.',
      image: '/Image/financial-fairness-claims1.webp',
      date: '29 August 2025',
      author: "Shannon Smith O'Connell",
      category: 'Guide',
    },
  ]

  return (
    <>
      <SEO
        title="Car Finance Claims Blog - Expert Guides & News | Your Claim Matters"
        description="Stay informed with the latest car finance claims news, guides, and expert insights. Learn about PCP claims, HP claims, and financial mis-selling compensation."
        keywords="car finance claims blog, PCP claims guide, HP claims news, financial mis-selling, car finance compensation news"
        url="/blogs"
        image="/Image/banks-delete-records-consumers-lose-billions.webp"
        imageAlt="Car finance claims blog and news"
        schemaType="Blog"
        schemaData={{
          mainEntity: {
            '@type': 'Blog',
            name: 'Your Claim Matters Car Finance Claims Blog',
            description:
              'Expert insights and news about car finance claims and compensation',
            publisher: {
              '@type': 'Organization',
              name: 'Your Claim Matters',
              url: 'https://yourclaimmatters.co.uk',
            },
            blogPost: blogPosts.map(post => ({
              '@type': 'BlogPosting',
              headline: post.title,
              description: post.excerpt,
              datePublished: new Date(post.date).toISOString(),
              author: {
                '@type': 'Person',
                name: post.author,
              },
              image: `https://yourclaimmatters.co.uk${post.image}`,
            })),
          },
        }}
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Blogs', url: '/blogs' },
        ]}
      />
      <div className="container mx-auto max-w-[95%] px-4 py-6 sm:max-w-[90%] md:py-8 lg:max-w-[85%] xl:max-w-[80%]">
        <div className="mb-6 flex items-start justify-between gap-4 md:mb-8">
          <h1 className="text-foreground text-2xl font-black tracking-tight uppercase sm:text-3xl md:text-4xl">
            BLOGS
          </h1>
          <div className="flex flex-wrap justify-end gap-1 sm:gap-2">
            <button className="bg-primary hover:bg-primary/80 rounded-full px-3 py-1.5 text-xs font-medium text-white transition-all duration-200 hover:scale-105 sm:px-4 sm:py-2 sm:text-sm">
              View all
            </button>
            <button className="bg-primary hover:bg-primary/80 rounded-full px-3 py-1.5 text-xs font-medium text-white transition-all duration-200 hover:scale-105 sm:px-4 sm:py-2 sm:text-sm">
              Guide
            </button>
            <button className="bg-primary hover:bg-primary/80 rounded-full px-3 py-1.5 text-xs font-medium text-white transition-all duration-200 hover:scale-105 sm:px-4 sm:py-2 sm:text-sm">
              News
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
          {blogPosts.map(post => {
            const BlogContainer = ({ children }) => {
              if (post.id === 1) {
                return (
                  <Link
                    to="/blogs/data-deletion-threatens-1bn-car-finance-compensation-uk-borrowers"
                    className="block overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm transition-all duration-200 hover:scale-[1.02] hover:shadow-md"
                  >
                    {children}
                  </Link>
                )
              }
              return (
                <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
                  {children}
                </div>
              )
            }

            return (
              <BlogContainer key={post.id}>
                <div className="aspect-video bg-gray-200">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-6">
                  <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4 md:mb-4">
                    <div className="flex items-center gap-2 sm:gap-4">
                      <span className="rounded bg-[#095678] px-2 py-1 text-xs font-medium text-white sm:px-3 sm:py-1">
                        {post.category}
                      </span>
                      <span className="font-raleway-numbers text-xs text-gray-600 sm:text-sm">
                        {post.date}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="h-5 w-5 rounded-full bg-gray-300 sm:h-6 sm:w-6"></div>
                      <span className="text-xs text-gray-600 sm:text-sm">
                        {post.author}
                      </span>
                    </div>
                  </div>
                  <h2 className="mb-2 text-lg leading-tight font-bold text-gray-900 sm:text-xl md:mb-3">
                    {post.title}
                  </h2>
                  <p className="line-clamp-3 text-sm leading-relaxed text-gray-600 sm:line-clamp-none">
                    {post.excerpt}
                  </p>
                </div>
              </BlogContainer>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default BlogsPage
